import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";
import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import * as ac from "../actions/actions";
import type { IntentApprovedTerms } from "app/pages/sales-intelligence/sub-modules/intent/types/common";
export const fetchSelectedIntentSignalTopicsThunk = () => {
    return async function fetchSelectedIntentTopics(
        dispatch: ThunkDispatchCommon,
        _: ThunkGetState,
        deps: ThunkDependencies,
    ) {
        dispatch(ac.fetchSelectedIntentTopics.request());

        try {
            const selectedIntentTopics = await deps.si.api.intent.fetchSelectedIntentTopic();
            return dispatch(ac.fetchSelectedIntentTopics.success(selectedIntentTopics));
        } catch (e) {
            return dispatch(ac.fetchSelectedIntentTopics.failure(e));
        }
    };
};

export const fetchSignalIntentTopicsDescriptionThunk = () => {
    return async function fetchIntentTopicsDescription(
        dispatch: ThunkDispatchCommon,
        _: ThunkGetState,
        deps: ThunkDependencies,
    ) {
        dispatch(ac.fetchIntentCategories.request());

        try {
            const categories = await deps.si.api.intent.fetchIntentTopicsDescription();
            return dispatch(ac.fetchIntentCategories.success(categories));
        } catch (e) {
            return dispatch(ac.fetchIntentCategories.failure(e));
        }
    };
};

export const fetchIntentUserApprovalThunk = () => {
    return async function fetchIntentManagementApproval(
        dispatch: ThunkDispatchCommon,
        _: ThunkGetState,
        deps: ThunkDependencies,
    ) {
        dispatch(ac.fetchIntentUserApproval.request());

        try {
            const intentApproval: IntentApprovedTerms = await deps.si.api.intent.fetchIntentApproval();
            return dispatch(ac.fetchIntentUserApproval.success(intentApproval));
        } catch (e) {
            return dispatch(ac.fetchIntentUserApproval.failure(e));
        }
    };
};

export const saveIntentUserApprovalThunk = () => {
    return async function saveIntentTopics(dispatch: ThunkDispatchCommon, _: ThunkGetState, deps: ThunkDependencies) {
        dispatch(ac.saveIntentUserApproval.request());

        try {
            const userApproval = await deps.si.api.intent.saveIntentUserApprovalTerms();
            return dispatch(ac.saveIntentUserApproval.success());
        } catch (e) {
            return dispatch(ac.saveIntentUserApproval.failure(e));
        }
    };
};
